export const CCP_CLIENT = "ccpclient";
export const DEXTR = "dextr";
